module.exports = __webpack_public_path__ + "static/media/sub-card-label-9.aadbb291.svg";